// eslint-disable-next-line max-len
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const namePattern = /^[A-Za-z-]*$/;
const pageButtonRenderer = (
  {
    page,
    active,
    onPageChange,
  },
) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  const activeStyle = {};
  if (active) {
    activeStyle.backgroundColor = '#962c30';
    activeStyle.color = 'white';
  } else {
    activeStyle.backgroundColor = '#f7f7f0';
    activeStyle.color = 'black';
  }
  if (typeof page === 'string') {
    activeStyle.backgroundColor = 'white';
    activeStyle.color = 'black';
  }
  return (
    <li className="page-item">
      <button className='btn btn-outline-light btn-md' onClick={ handleClick } style={ activeStyle }>{ page }</button>
    </li>
  );
};
const customTotal = (from, to, size) => (
  <span className="react-bootstrap-table-pagination-total custom-total ml">
    Showing { from } to { to } of { size } Results
  </span>
);

export {
  emailPattern,
  namePattern,
  customTotal,
  pageButtonRenderer,
};
